import { cloneDeep, isArray } from 'lodash';
var arrayProto = Array.prototype;
export var arrayMethods = Object.create(arrayProto);
var methodsToPatch = ['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse', 'clear'];
export function HookSetup(handler, ObjectToMap, parent) {
    if (parent === void 0) { parent = ''; }
    if (!ObjectToMap)
        return ObjectToMap;
    if (ObjectToMap && typeof ObjectToMap === 'object' && ObjectToMap._s_stored === true)
        return ObjectToMap;
    if (isArray(ObjectToMap)) {
        var name_1 = parent ? "".concat(parent) : "";
        var mappedValue = ObjectToMap;
        var _loop_1 = function (method) {
            var original = arrayProto[method];
            mappedValue[method] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var result = original.apply(this, args);
                for (var _a = 0, _b = this; _a < _b.length; _a++) {
                    var item = _b[_a];
                    if (typeof item === 'object') {
                        HookSetup(handler, item, name_1);
                    }
                }
                handler(name_1, result, this);
                return result;
            };
        };
        for (var _i = 0, methodsToPatch_1 = methodsToPatch; _i < methodsToPatch_1.length; _i++) {
            var method = methodsToPatch_1[_i];
            _loop_1(method);
        }
        for (var _a = 0, mappedValue_1 = mappedValue; _a < mappedValue_1.length; _a++) {
            var item = mappedValue_1[_a];
            //console.debug(new Date(), 'setup array 2',name)
            if (typeof item === 'object') {
                HookSetup(handler, item, name_1);
            }
        }
    }
    else if (typeof ObjectToMap === 'object') {
        try {
            ObjectToMap._s_stored = true;
        }
        catch (error) { }
        var _loop_2 = function (key) {
            var name_2 = parent ? "".concat(parent, ".").concat(key) : "".concat(key);
            if (ObjectToMap[key] === undefined || ObjectToMap[key] === null || ['string', 'number', 'boolean', 'Date'].includes(typeof ObjectToMap[key])) {
                var mappedValue_3 = ObjectToMap[key];
                Object.defineProperty(ObjectToMap, key, {
                    get: function () {
                        return mappedValue_3;
                    },
                    set: function (value) {
                        if (mappedValue_3 !== value) {
                            var old = mappedValue_3;
                            if (typeof value === 'object')
                                mappedValue_3 = HookSetup(handler, value, name_2);
                            else
                                mappedValue_3 = value;
                            handler(name_2, mappedValue_3, old);
                        }
                    }
                });
            }
            else if (isArray(ObjectToMap[key])) {
                var mappedValue_4 = ObjectToMap[key];
                var _loop_3 = function (method) {
                    var original = arrayProto[method];
                    mappedValue_4[method] = function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var result = original.apply(this, args);
                        for (var _a = 0, _b = this; _a < _b.length; _a++) {
                            var item = _b[_a];
                            //console.debug(new Date(), 'setup array 3',name)
                            if (typeof item === 'object') {
                                HookSetup(handler, item, name_2);
                            }
                        }
                        handler(name_2, result, this);
                        return result;
                    };
                };
                for (var _d = 0, methodsToPatch_2 = methodsToPatch; _d < methodsToPatch_2.length; _d++) {
                    var method = methodsToPatch_2[_d];
                    _loop_3(method);
                }
                for (var _e = 0, mappedValue_2 = mappedValue_4; _e < mappedValue_2.length; _e++) {
                    var item = mappedValue_2[_e];
                    //console.debug(new Date(), 'setup array 4',name)
                    if (typeof item === 'object') {
                        HookSetup(handler, item, name_2);
                    }
                }
                Object.defineProperty(ObjectToMap, key, {
                    get: function () {
                        return mappedValue_4;
                    },
                    set: function (value) {
                        if (mappedValue_4 !== value) {
                            var old = null; //cloneDeep( mappedValue );
                            if (typeof value === 'object' || isArray(value)) {
                                mappedValue_4 = HookSetup(handler, value, name_2);
                            }
                            else
                                mappedValue_4 = value;
                            handler(name_2, mappedValue_4, old);
                        }
                    }
                });
            }
            else if (typeof ObjectToMap[key] === 'function') {
            }
            else if (typeof ObjectToMap[key] === 'object') {
                var mappedValue_5 = HookSetup(handler, ObjectToMap[key], name_2);
                try {
                    ObjectToMap._s_stored = true;
                }
                catch (error) { }
                Object.defineProperty(ObjectToMap, key, {
                    get: function () {
                        return mappedValue_5;
                    },
                    set: function (value) {
                        if (mappedValue_5 !== value) {
                            var old = cloneDeep(mappedValue_5);
                            if (typeof value === 'object')
                                mappedValue_5 = HookSetup(handler, value, name_2);
                            else
                                mappedValue_5 = value;
                            handler(name_2, mappedValue_5, old);
                        }
                    }
                });
            }
        };
        for (var _b = 0, _c = Object.keys(ObjectToMap).filter(function (x) { return x !== 'Handler' && !x.startsWith('_'); }); _b < _c.length; _b++) {
            var key = _c[_b];
            _loop_2(key);
        }
    }
    return ObjectToMap;
}
